import UserManagementContainer from "../../../../Component/Application/Users/UserManagement/UserManagement";

const UserManagement = () => {
  return (
    <div className='page-body'>
      <UserManagementContainer />
    </div>
  );
};

export default UserManagement;

